import Stack from '@ahamove/web-components/lib/Stack';
import Typography from '@ahamove/web-components/lib/Typography';
import { EmptyServiceModelsIcon } from '@/lib/icons';
import useIsMobile from '@/shared-hooks/useIsMobile';

type Props = {
  title?: string;
};

export default function EmptyServiceModels({
  title = 'Không có bảng giá thuê trong khu vực này',
}: Props) {
  const isMobile = useIsMobile();

  return (
    <Stack
      direction="column"
      spacing={isMobile ? 2 : 2.75}
      justifyContent="center"
      alignItems="center"
      mx="auto"
      px={isMobile ? 2 : 5}
      py={isMobile ? 8 : 10.625}
    >
      <EmptyServiceModelsIcon />
      <Typography variant="h4" color="grey.500" textAlign="center">
        {title}
      </Typography>
    </Stack>
  );
}
